import { DivIcon } from "leaflet";
import { OverlayScrollbarsComponent } from "overlayscrollbars-react";
import { useEffect, useState } from "react";
import { slugify } from "../../../utils/string";

// import CreacycleTypeInfosItem from "./inc/CreacycleTypeInfosItem";

const InstitutionInfos = ({
  selectedInstitution,
  setSelectedInstitution,
  setMapScreen,
  filters,
}) => {
  const [isActive, setIsActive] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);

  //--- Manage state that "display" the pop-up
  useEffect(() => {
    if (selectedInstitution) {
      setIsActive(true);
    } else {
      setIsActive(false);
    }
  }, [selectedInstitution]);

  // let institutionType = [];
  // if (selectedInstitution.typeInfos) {
  //   institutionType = selectedInstitution.typeInfos.map((infos, index) => {
  //     return <CreacycleTypeInfosItem infos={infos} filters={filters} key={infos.name + index} />;
  //   });
  // }

  let tags = selectedInstitution?.tags?.map((tag, i) => {
    if (i === 0) {
      return (
        <div
          className="tag tag--activity"
          style={{ backgroundColor: tag?.color }}
        >
          {tag.name}
        </div>
      );
    } else {
      return <div className="tag">{tag.name}</div>;
    }
  });

  const handleFullScreen = () => {
    setIsFullScreen((prev) => !prev);
  };

  const handleClose = () => {
    setSelectedInstitution("");
  };

  return (
    <div
      className={`institution-infos ${isActive ? "active" : ""} ${
        isFullScreen ? "fullscreen" : ""
      } ${
        process.env.REACT_APP_SIDEBAR === "right"
          ? "institution-infos--right"
          : ""
      }`}
    >
      <OverlayScrollbarsComponent className="overlay-scrollbar os-theme-dark">
        <div className="row no-gutters">
          <div className="col-12">
            <div className="">
              <button
                className="inst-info__btn-fullscreen"
                onClick={() => handleFullScreen()}
              >
                {isFullScreen ? (
                  <span className="icon iconReactLeafletreduire">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                  </span>
                ) : (
                  <span className="icon iconReactLeafletagrandir">
                    <span className="path1"></span>
                    <span className="path2"></span>
                    <span className="path3"></span>
                  </span>
                )}
              </button>
              <button
                className="inst-info__btn-close"
                onClick={() => handleClose()}
              >
                <span className="icon iconReactLeafletclose">
                  <span className="path1"></span>
                  <span className="path2"></span>
                </span>
              </button>
              {selectedInstitution?.picture && (
                <div className="inst-info__img-wrapper">
                  <img
                    className="w-100"
                    src={selectedInstitution?.picture}
                    alt=""
                    height="160px"
                  />
                </div>
              )}
            </div>
            <div className="inst-info__title">
              <h4 className="">{selectedInstitution.name}</h4>
            </div>
          </div>
          {tags?.length > 0 && (
            <div className="inst-info__tags-wrapper">{tags}</div>
          )}
          {selectedInstitution.address && (
            <div className="inst-info__address">
              {selectedInstitution.address}
            </div>
          )}
          {selectedInstitution?.contact && (
            <div className="inst-info__contact">
              {selectedInstitution.contact}
            </div>
          )}
          {selectedInstitution.phone && (
            <div className="inst-info__phone">{selectedInstitution.phone}</div>
          )}
          {selectedInstitution?.schedule && (
            <div
              className="inst-info__schedule"
              dangerouslySetInnerHTML={{
                __html: selectedInstitution.schedule,
              }}
            ></div>
          )}

          {selectedInstitution?.website && (
            <a
              className="inst-info__button"
              href={`${selectedInstitution.website}`}
            >
              Voir l'établissement
            </a>
          )}
        </div>
        <div className="inst-info__container" style={{ height: "500px" }}>
          <div
            dangerouslySetInnerHTML={{
              __html: selectedInstitution.description,
            }}
          ></div>
        </div>
      </OverlayScrollbarsComponent>
    </div>
  );
};

export default InstitutionInfos;
